import { types } from '../actions/SessionActions';

const defaultState = {
    appReady: false,
    navigationLock: { isLocked: false, reason: null, owner: null },
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case types.SESSION_SET_REQUEST_PARAMETER_IDS:
        return Object.assign({}, state, {
            requestParameterIds: action.parameterIds,
        });

    case types.SESSION_SET_APP_READY:
        return Object.assign({}, state, {
            appReady: true,
        });

    case types.SESSION_SET_CAPTIONS_LOADED:
        return Object.assign({}, state, {
            captionsLoaded: true,
        });

    case types.SESSION_SET_LANGUAGE:
        return Object.assign({}, state, { language: action.language });

    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/SessionReducer.js
 **/